import UserAddbook from "./components/myaccount/address/UserAddbook";

function Addressbook() {
    return (
        <>
            <UserAddbook />
        </>
    );
}

export default Addressbook;